export default {
    methods: {
        /**
         * Return Data sub-object of API Request Object (ignore other data of request like status, pagination, etc.)
         * 
         * @param {object} response - Response of API request
         * @return {object}
         */
        getDataFromRequestResponse(response) {
            if (response.data !== undefined && response.data !== null)
                return response.data
            return []
        },
    },
}